import { StoreBodyBlock } from './enums';

export const MERGEABLE_BODY_BLOCKS: Set<StoreBodyBlock> = new Set([
  StoreBodyBlock.dailyBonusBadge,
  StoreBodyBlock.rewardCalendar,
  StoreBodyBlock.triggeredPopups
]);

export const DEFAULT_BODY_BLOCKS_ORDER: StoreBodyBlock[] = [
  StoreBodyBlock.dailyBonusBadge,
  StoreBodyBlock.rewardCalendar,
  StoreBodyBlock.triggeredPopups,
  StoreBodyBlock.playerLevel,
  StoreBodyBlock.banners,
  StoreBodyBlock.progressBars,
  StoreBodyBlock.rollingOffers,
  StoreBodyBlock.specialOffers,
  StoreBodyBlock.bundles,
  StoreBodyBlock.richText
];

export type OnePlusManyInstanceId = `${StoreBodyBlock.onePlusMany}_${number}`;

export type BodyBlockId = StoreBodyBlock | OnePlusManyInstanceId;

export const ONE_PLUS_MANY_INSTANCE_PATTERN = /^onePlusMany_(\d+)$/;

export const isOnePlusManyInstanceId = (
  id: string
): id is OnePlusManyInstanceId => ONE_PLUS_MANY_INSTANCE_PATTERN.test(id);

export const parseOnePlusManySuffix = (id: OnePlusManyInstanceId): number => {
  const match = id.match(ONE_PLUS_MANY_INSTANCE_PATTERN);
  if (!match) {
    throw new Error(
      `parseOnePlusManySuffix: id "${id}" does not match the onePlusMany_<N> pattern`
    );
  }
  return Number(match[1]);
};

export const buildOnePlusManyInstanceId = (
  suffix: number
): OnePlusManyInstanceId => `onePlusMany_${suffix}` as OnePlusManyInstanceId;

export const getBaseBlockType = (id: BodyBlockId): StoreBodyBlock =>
  isOnePlusManyInstanceId(id)
    ? StoreBodyBlock.onePlusMany
    : (id as StoreBodyBlock);
